import type { BuilderElement } from '@/utils/builder/types';
import { generateId } from '@/utils/builder/id-utils';

const createAccordionItem = (
  title: string,
  question: string,
  answer: string
): BuilderElement => {
  const containerId = generateId();
  const questionId = generateId();
  const answerId = generateId();

  return {
    id: containerId,
    type: 'container',
    content: title,
    styles: {
      overflow: 'hidden',
    },
    children: [
      {
        id: questionId,
        type: 'heading',
        accordionRole: 'question',
        content: question,
        styles: {
          fontSize: '18px',
          fontWeight: '600',
          padding: '16px',
          margin: '0',
          backgroundColor: '#f9fafb',
          cursor: 'pointer',
        },
        _isNew: true,
        _needsSync: true,
      },
      {
        id: answerId,
        type: 'paragraph',
        accordionRole: 'answer',
        content: answer,
        styles: {
          padding: '16px',
          margin: '0',
        },
        _isNew: true,
        _needsSync: true,
      },
    ],
    _isNew: true,
    _needsSync: true,
  };
};

export const createDefaultAccordionElement = (): BuilderElement => {
  const id = generateId();

  return {
    id,
    type: 'accordion',
    allowMultiple: false,
    defaultOpen: false,
    accordionType: 'single',
    itemBorderRadius: '8px',
    itemBorder: '1px solid #e5e7eb',
    styles: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      padding: '20px',
      margin: '10px 0',
      gap: '16px',
    },
    children: [
      createAccordionItem(
        'Accordion Item 1',
        'What is this?',
        'This is the content for accordion item 1. You can add any content here.'
      ),
      createAccordionItem(
        'Accordion Item 2',
        'How does it work?',
        'This is the content for accordion item 2. Click to expand or collapse.'
      ),
    ],
    _isNew: true,
    _needsSync: true,
  };
};


